import {
    Directive,
    output,
    EventEmitter,
    OnInit,
    ElementRef,
    Input,
    NgZone,
    OnChanges,
    SimpleChanges,
    SimpleChange,
    inject,
} from '@angular/core';
import { fromEvent, interval, Observable } from 'rxjs';
import { debounce, filter } from 'rxjs/operators';
import { WhenScrolledService } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.service';
import { findClosest, isDefined } from '@fi-shared/utils';

@Directive({
    selector: '[fiWhenScrolled]',
    standalone: false,
})
// todo check BalooSyncLogListComponent, PkImportLogComponent, MediaBankNewListComponent, FiChecklist2TemplateListComponent
// todo: fix building of mobile app and check FicPriorityFeedComponent, FicSocialFeedComponent
export class WhenScrolledDirective implements OnInit, OnChanges {
    @Input() fiWhenScrolledListDisplayedItems: number;
    @Input() fiWhenScrolledToTopMode = false;
    @Input() fiWhenScrolledElSelector: string; // find parent scrollable element by selector
    @Input() fiWhenScrolledDisabled: boolean; // workaround for grid/table modes
    
    public fiWhenScrolled = output<void>();

    private elementRef = inject(ElementRef<HTMLElement>);
    private ngZone = inject(NgZone);
    private whenScrolledService = inject(WhenScrolledService);

    ngOnInit(): void {
        fromEvent(this.getScrollElement(), 'scroll')
            .pipe(filter(() => !this.whenScrolledService.isScrollEventIgnored()))
            .pipe(debounce(() => interval(200)))
            .subscribe(() => this.checkScroll());

        this.checkScroll();
    }

    ngOnChanges(changes: SimpleChanges) {
        const change: SimpleChange = changes.fiWhenScrolledListDisplayedItems;
        if (change && !change.firstChange) {
            this.checkOnDisplayedItemsChanged();
        }
    }

    private prevScrollHeight: number = 0;
    private renderTimeout = 500; // we need this timeout at 1st time, because when switching from other tab there is delay because of animation
    private checkOnDisplayedItemsChanged() {
        if (this.fiWhenScrolledDisabled) {
            return;
        }
        setTimeout(() => {
            // allow new elements to render
            const el = this.getScrollElement();
            if (el.scrollHeight === el.clientHeight || el.scrollHeight === this.prevScrollHeight) {
                // there is no scroll after loading another portion of elements, try to load next one
                this.fiWhenScrolled.emit();
            }

            this.prevScrollHeight = el.scrollHeight;
        }, this.renderTimeout);
        this.renderTimeout = 50;
    }

    private checkScroll() {
        if (this.fiWhenScrolledDisabled) return;
        const el = this.getScrollElement();

        // scroll to 30% left of the client height
        //const scrollOffsetToLoad = raw.getBoundingClientRect().height * 0.3;

        const maxScrollPosition = el.scrollHeight - el.clientHeight;

        if (
            maxScrollPosition > 0 &&
            ((!this.fiWhenScrolledToTopMode && el.scrollTop / maxScrollPosition > 0.7) ||
                (this.fiWhenScrolledToTopMode && -el.scrollTop / maxScrollPosition > 0.7))
        ) {
            this.fiWhenScrolled.emit();
        }
    }

    private getScrollElement() {
        if (this.fiWhenScrolledElSelector) {
            return findClosest(this.elementRef.nativeElement, this.fiWhenScrolledElSelector);
        }
        return this.elementRef.nativeElement;
    }
}
